import { defineStore } from "pinia";
import DefaultLogo from '@/assets/images/zelfPOS-logo.png';

const DEFAULT_SYSTEM_NAME = "ZelfPOS";

export const useSystemSettingsStore = defineStore("systemSettings", {
  state: () => ({
    cdsClientId: "",
    i18nLng: null,
    isSidebarOpen: false,
    logo: DefaultLogo,
    posClientId: "",
    systemName: DEFAULT_SYSTEM_NAME,
  }),
  actions: {
    getCdsClientId() {
      return this.cdsClientId;
    },
    getLanguage() {
      return this.i18nLng;
    },
    getLogo() {
      return this.logo;
    },
    getPosClientId() {
      return this.posClientId;
    },
    getSidebarState() {
      return this.isSidebarOpen;
    },
    getSystemName() {
      return this.systemName;
    },
    setCdsClientId(id) {
      this.cdsClientId = id;
    },
    setLanguage(languageObject) {
      this.i18nLng = languageObject;
    },
    setLogo(logoUrl) {
      this.logo = logoUrl;
    },
    setDefaultLogo() {
      this.logo = DefaultLogo;
    },
    setPosClientId(id) {
      this.posClientId = id;
    },
    setSidebarState(state) {
      this.isSidebarOpen = state;
    },
    setSystemName(name) {
      this.systemName = name;
    },
    setDefaultSystemName() {
      this.systemName = DEFAULT_SYSTEM_NAME;
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    resetSystemSettings() {
      this.cdsClientId = "";
      this.i18nLng = null;
      this.isSidebarOpen = false;
      this.logo = DefaultLogo;
      this.posClientId = "";
      this.systemName = DEFAULT_SYSTEM_NAME;
    },
  },
  persist: {
    storage: localStorage,
    paths: ["cdsClientId", "i18nLng", "isSidebarOpen", "logo", "posClientId", "systemName"],
  },
});